/* ================================================
   MAUVAIS GARÇON — Main App Initializer
   ================================================ */

document.addEventListener('DOMContentLoaded', () => {
  const _isMobile = window.matchMedia('(max-width: 768px)').matches;

  if (!_isMobile) {
    window.mgWM   = new MGWindowManager();
    window.mgGame = new MGMinesweeper('mg-minesweeper-container');

    // ---- Taskbar clock ----
    const updateClock = () => {
      const el = document.getElementById('mg-taskbar-clock');
      if (el) el.textContent = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };
    updateClock();
    setInterval(updateClock, 30000);
  }

  // ---- Reset progress on tab close ----
 window.addEventListener('beforeunload', () => {
  localStorage.removeItem('mg_progress');
});
window.addEventListener('pagehide', () => {
  localStorage.removeItem('mg_progress');
});
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'hidden') {
    localStorage.removeItem('mg_progress');
  }
});

  window.mgUpdateUnlockCount = () => {}; // counter removed from taskbar

  // ---- "Play Now" button ----
  document.getElementById('btn-start-game')?.addEventListener('click', () => {
    const gameWin = document.getElementById('win-game');
    if (gameWin) {
      gameWin.style.display = 'flex';
      window.mgWM.restore('win-game');
    }
  });

    // ---- Cart bubble dismiss on outside click ----
  document.addEventListener('click', e => {
    const bubble = document.getElementById('mg-cart-bubble');
    const wrap = document.getElementById('mg-cart-wrap');
    if (bubble && wrap && !wrap.contains(e.target)) {
      bubble.classList.remove('mg-bubble-visible');
    }
  });

  // ---- Start menu toggle ----
  const startBtn  = document.getElementById('mg-taskbar-start');
  const startMenu = document.getElementById('mg-start-menu');
  startBtn?.addEventListener('click', e => {
    e.stopPropagation();
    const open = startMenu.style.display === 'flex';
    startMenu.style.display = open ? 'none' : 'flex';
  });
  document.addEventListener('click', () => {
    if (startMenu) startMenu.style.display = 'none';
  });

  // ---- Newsletter popup ----
  document.getElementById('mg-start-newsletter')?.addEventListener('click', () => {
    if (startMenu) startMenu.style.display = 'none';
    if (document.getElementById('win-newsletter')) {
      window.mgWM.restore('win-newsletter'); return;
    }
    const content = `
      <div class="mg-newsletter-content">
        <h3>Stay in the loop.</h3>
        <p>Be the first to know about new drops, exclusive unlocks, and whatever we're up to.</p>
        <input class="mg-newsletter-input" id="mg-nl-email" type="email" placeholder="your@email.com">
        <button class="mg-newsletter-btn" id="mg-nl-submit">Subscribe →</button>
        <div class="mg-newsletter-success" id="mg-nl-success">✓ You're in. Watch your inbox.</div>
      </div>`;
    window.mgWM.create({ id: 'win-newsletter', title: 'Keep in Touch', content, x: 80, y: 120, width: 280, icon: '📬' });
    setTimeout(() => {
      document.getElementById('mg-nl-submit')?.addEventListener('click', () => {
        const email = document.getElementById('mg-nl-email')?.value?.trim();
        if (!email || !email.includes('@')) {
          document.getElementById('mg-nl-email')?.focus(); return;
        }
        // Submit to Shopify customer subscribe endpoint
        fetch('/contact', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: 'form_type=customer&utf8=✓&contact[email]=' + encodeURIComponent(email)
        }).catch(() => {}); // fail silently — confirmation shows regardless
        document.getElementById('mg-nl-submit').style.display  = 'none';
        document.getElementById('mg-nl-email').style.display   = 'none';
        document.getElementById('mg-nl-success').style.display = 'block';
      });
    }, 50);
  });

  // ---- Re-show previously unlocked tiers on page load (desktop only) ----
  if (!_isMobile) {
    const progress = MG_UNLOCK.getProgress();
    (progress.unlockedTiers || []).forEach((tier, i) => {
      const product = (window.MG_PRODUCTS || [])[tier];
      if (product) setTimeout(() => mgShowUnlockWindow(tier, product), 600 + i * 250);
    });
  }

  // ---- Cart counter ----
  function mgUpdateCartCount(n) {
    document.querySelectorAll('.mg-cart-badge').forEach(el => {
      el.textContent   = n;
      el.dataset.count = n;
    });
  }
  fetch('/cart.js')
    .then(r => r.json())
    .then(c => mgUpdateCartCount(c.item_count))
    .catch(() => {});
  window.mgRefreshCart = () =>
    fetch('/cart.js').then(r => r.json()).then(c => mgUpdateCartCount(c.item_count)).catch(() => {});

  // ---- Mobile tap game ----
  (function initMobileTapGame() {
    const tapBtn     = document.getElementById('mg-mobile-tap-btn');
    const tapCount   = document.getElementById('mg-mobile-tap-count');
    const tapBarFill = document.getElementById('mg-mobile-tap-bar-fill');
    const unlockedEl = document.getElementById('mg-mobile-unlocked');
    if (!tapBtn) return;

    const TAPS_PER_TIER = 15;
    let taps = 0;

    function addTierCard(tierIdx) {
      if (document.getElementById('mobile-card-' + tierIdx)) return;
      const product     = (window.MG_PRODUCTS || [])[tierIdx];
      const name        = product ? product.name    : 'Tier ' + (tierIdx + 1);
      const url         = product && product.handle ? '/products/' + product.handle : '/';
      const img         = product && product.image  ? product.image : '';
      const details     = product && product.details ? product.details : '';
      const extraSizes = [2,3,6,9].indexOf(tierIdx) !== -1 ? '<option value="3XL">3XL</option><option value="4XL">4XL</option><option value="5XL">5XL</option>' : '';
      const imgHtml     = img
        ? `<div class="mg-mobile-unlock-card-img-wrap"><img src="${img}" alt="${name}" class="mg-mobile-unlock-card-img"></div>`
        : `<div class="mg-mobile-unlock-card-img-wrap mg-mobile-unlock-card-img-placeholder">🔓</div>`;
      const detailsHtml = details
        ? `<div class="mg-mobile-unlock-card-details">${details}</div>`
        : '';

      const card = document.createElement('div');
      card.className = 'mg-mobile-unlock-card';
      card.id = 'mobile-card-' + tierIdx;
      card.innerHTML = `
        ${imgHtml}
        <div class="mg-mobile-unlock-card-info">
          <div class="mg-mobile-unlock-card-badge">🔓 Tier ${tierIdx + 1} of ${MG_UNLOCK.TOTAL_TIERS} Unlocked</div>
          <div class="mg-mobile-unlock-card-name">${name}</div>
          ${detailsHtml}
          ${product && product.hideSize ? '' : `<select class="mg-mobile-unlock-size-select" id="mg-msize-${tierIdx}">
            <option value="">— Select Size —</option>
            <option value="S">S</option>
            <option value="M">M</option>
            <option value="L">L</option>
            <option value="XL">XL</option>
            <option value="2XL">2XL</option>
            ${extraSizes}
          </select>`}
          <button class="mg-mobile-unlock-card-link" onclick="mgAddToCart('${product ? product.handle : ''}',document.getElementById('mg-msize-${tierIdx}'),this)">Add to Cart →</button>
        </div>`;
      if (unlockedEl) unlockedEl.appendChild(card);
    }

    // No on-load restore — tiers only appear when earned this session

    tapBtn.addEventListener('click', () => {
      taps++;
      const rem   = taps % TAPS_PER_TIER;
      const shown = rem === 0 ? TAPS_PER_TIER : rem;

      if (tapCount)   tapCount.textContent  = `${shown} / ${TAPS_PER_TIER}`;
      if (tapBarFill) tapBarFill.style.width = `${(shown / TAPS_PER_TIER) * 100}%`;

      if (taps % TAPS_PER_TIER === 0) {
        // Fire 3 safe-clicks worth to trigger one tier unlock
  let newTiers = [];
for (let i = 0; i < 3; i++) {
  const t = MG_UNLOCK.recordSafeClick();
  if (t !== null) newTiers.push(t);
}
newTiers.forEach(tier => addTierCard(tier));
if (newTiers.length > 0) {
  tapBtn.textContent = 'YES 🎉';
  setTimeout(() => { tapBtn.textContent = 'YES'; }, 1200);
}
        setTimeout(() => {
          if (tapCount)   tapCount.textContent  = `0 / ${TAPS_PER_TIER}`;
          if (tapBarFill) tapBarFill.style.width = '0%';
          taps = 0;
        }, 1200);
      }
    });
  })();
});

/* ---- Called by minesweeper when a new tier is unlocked ---- */
window.mgOnUnlock = function (tierIndex) {
  window.mgUpdateUnlockCount();
  const product = (window.MG_PRODUCTS || [])[tierIndex];
  if (product) {
    setTimeout(() => {
      mgShowUnlockWindow(tierIndex, product);
      setTimeout(() => mgShowRandomAd(), 600);
    }, 350);
  }
};

/* ---- AJAX Add to Cart ---- */
async function mgAddToCart(handle, sizeSelectEl, btnEl) {
  if (!handle) return;

  // Require size selection if selector is present
  if (sizeSelectEl && !sizeSelectEl.value) {
    sizeSelectEl.style.outline = '2px solid #e03030';
    sizeSelectEl.focus();
    return;
  }
  if (sizeSelectEl) sizeSelectEl.style.outline = '';

  const size = sizeSelectEl ? sizeSelectEl.value : null;
  const orig = btnEl.textContent;
  btnEl.textContent = 'Adding…';
  btnEl.disabled = true;

  try {
    const product = await fetch('/products/' + handle + '.js').then(r => r.json());
    let variant = size
            ? product.variants.find(v => v.title === size || v.option1 === size || v.option2 === size)
      : null;
    if (!variant) variant = product.variants[0];
    if (!variant) throw new Error('no variant');

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variant.id, quantity: 1 })
    });

    btnEl.textContent = '✓ Added to Cart!';
    btnEl.style.background = 'linear-gradient(to bottom,#2a7a2a,#1a5a1a)';
    if (window.mgRefreshCart) window.mgRefreshCart();
    setTimeout(() => {
      btnEl.textContent = orig;
      btnEl.style.background = '';
      btnEl.disabled = false;
    }, 2500);

  } catch(err) {
    btnEl.textContent = 'Error — Try Again';
    btnEl.style.background = 'linear-gradient(to bottom,#e03030,#aa1a1a)';
    setTimeout(() => {
      btnEl.textContent = orig;
      btnEl.style.background = '';
      btnEl.disabled = false;
    }, 2500);
  }
}

/* ---- Unlock popup window ---- */
function mgShowUnlockWindow(tierIndex, product) {
  if (!window.mgWM) return;
  const id  = 'win-unlock-' + tierIndex;
  const url = product.handle ? '/products/' + product.handle : '/';
  const extraSizes = [2,3,6,9].indexOf(tierIndex) !== -1 ? '<option value="3XL">3XL</option><option value="4XL">4XL</option><option value="5XL">5XL</option>' : '';

  const imgHtml = product.image && product.image !== ''
? `<img src="${product.image}" alt="${product.name}" class="mg-unlock-product-img mg-unlock-product-img-zoom" title="Click to enlarge" style="cursor:zoom-in;" onclick="mgShowImagePreview(this.src, this.alt);">`
    : `<div class="mg-unlock-placeholder-img">🔓</div>`;

  const detailsHtml = product.details
    ? `<div class="mg-unlock-product-details">${product.details}</div>`
    : '';

  const content = `
    <div class="mg-unlock-content">
      <div class="mg-unlock-badge">🔓 &nbsp;UNLOCKED</div>
      <div class="mg-unlock-tier">TIER ${tierIndex + 1} of ${MG_UNLOCK.TOTAL_TIERS}</div>
      ${imgHtml}
      <div class="mg-unlock-product-name">${product.name}</div>
      ${detailsHtml}
      ${product.hideSize ? '' : `<select class="mg-unlock-size-select" id="mg-size-${tierIndex}">
        <option value="">— Select Size —</option>
        <option value="S">S</option>
        <option value="M">M</option>
        <option value="L">L</option>
        <option value="XL">XL</option>
        <option value="2XL">2XL</option>
        ${extraSizes}
      </select>`}
      <button class="mg-btn-unlock-shop" onclick="mgAddToCart('${product.handle}',document.getElementById('mg-size-${tierIndex}'),this)">Add to Cart →</button>
    </div>`;

  const col = tierIndex % 4;
  const row = Math.floor(tierIndex / 4);
  const x   = 140 + col * 35 + Math.round(Math.random() * 30);
  const y   = 90  + row * 35 + Math.round(Math.random() * 30);

  window.mgWM.create({ id, title: '🎉 New Drop Unlocked!', content, x, y, width: 280, icon: '🎁', className: 'mg-window-unlock' });
}

/* ---- Image preview window ---- */
function mgShowImagePreview(src, altText) {
  if (!window.mgWM) return;
  const id = 'win-img-preview-' + Math.random().toString(36).slice(2, 10);
  const content = `<div class="mg-img-preview-wrap"><img src="${src}" alt="${altText}" class="mg-img-preview-full"></div>`;
  const desktop = document.getElementById('mg-desktop');
  const dw = desktop?.offsetWidth || 900;
  const dh = desktop?.offsetHeight || 600;
  const x = Math.max(20, Math.floor((dw - 420) / 2));
  const y = Math.max(20, Math.floor((dh - 460) / 2));
  const win = window.mgWM.create({ id, title: altText, content, x, y, width: 420, icon: '🖼', className: 'mg-window-imgpreview' });
  const controls = win.querySelector('.mg-window-controls');
  if (controls) controls.innerHTML = '<button onclick="window.mgWM.close(\'' + id + '\')" title="Close">&#x2715;</button>';
}

/* ---- Ad popup system ---- */
const _shownAds = new Set();

function mgShowRandomAd() {
  const allAds    = Array.from(document.querySelectorAll('.mg-window-ad'));
  const available = allAds.filter(a => !_shownAds.has(a.id));
  if (available.length === 0) return;

  const ad = available[Math.floor(Math.random() * available.length)];
  _shownAds.add(ad.id);

  const desktop = document.getElementById('mg-desktop');
  const dw = desktop?.offsetWidth  || 900;
  const dh = desktop?.offsetHeight || 600;

  ad.style.left    = Math.max(10, Math.floor(Math.random() * (dw - 300))) + 'px';
  ad.style.top     = Math.max(10, Math.floor(Math.random() * (dh * 0.65))) + 'px';
  ad.style.display = 'flex';

  if (window.mgWM) window.mgWM.restore(ad.id);

  if (_shownAds.size < allAds.length) {
    setTimeout(() => mgShowRandomAd(), 10000 + Math.random() * 8000);
  }
}
